import React from 'react';
import PropTypes from 'prop-types';

import './navigator.css';

class NavigatorLine extends React.Component {
    constructor(props) {
        super(props);

        this.getStepSegment = this.getStepSegment.bind(this);
    }

    getStepSegment(current) {
        const { steps, activeStep, progress } = this.props;

        let classes = 'step-segment';
        if (current < progress) {
            classes = `${classes} complete`;
        }
        if (current === activeStep) {
            classes = `${classes} active`;
        }

        return <div key={current} style={{ width: `${100 / steps.length}%` }} className={classes} />;
    }

    render() {
        const { steps } = this.props;

        return (
            <div className="row section navigator">
                <div className="col-xs-12">
                    <div className="navigator-line">{steps && steps.map((_, i) => this.getStepSegment(i))}</div>
                </div>
            </div>
        );
    }
}

NavigatorLine.defaultProps = {
    steps: undefined,
    activeStep: 0,
    progress: 0
};

NavigatorLine.propTypes = {
    steps: PropTypes.array,
    activeStep: PropTypes.number,
    progress: PropTypes.number
};

export default NavigatorLine;



// WEBPACK FOOTER //
// ./src/components/wizard/navigator/line.jsx